//import axios from 'axios';//循環参照になる
import React, { useContext, useState } from "react";
import { LayoutFlagContext } from "./providers/LayoutFlagProvider";
import { animateScroll as scroll } from "react-scroll";

//components
import Results from "./Results";
import Errors from "./Errors";
import Loading from "./Loading";
import Btn from "./Btn";


const App = () => {

    let ajaxUrl = window.ajaxUrl + '?action=get_cattle_id&cid=';
    let ajaxNonce = window.ajaxNonce;

    //let searchInput = '';//検索ワード
    const [searchInput, setSearchInput] = useState('');//入力値チェック
    const [errorMsg, setErrorMsg] = useState('');//入力内容のエラーメッセージ
    const [loadingMsg, setloadingMsg] = useState('');//Loading時メッセージ
    const [searchResultData, setSearchResultData] = useState([]);//検索結果をsearchResultDataに格納

    //context
    const {layoutMode, setLayoutMode} = useContext(LayoutFlagContext);
    
    //https://nishinatoshiharu.com/react-context-cases/
    //useContextをuseState・useReducer・関数と組み合わせる方法


    const handleChangeText = (e) => {
        setSearchInput(e.target.value);
        //console.log(layoutMode);
    };

    const handleBackBtn = () => {
        //e.preventDefault();
        setLayoutMode('initial');//戻るボタン: 画面切り替え
        setSearchResultData([]);//検索結果初期化
        scroll.scrollToTop();
    };

    const handleSubmit = (e) => {
        e.preventDefault();//submitイベントをキャンセル
        let errorFlg = false;// 入力文字チェック
        setErrorMsg('');//エラーメッセージ初期化
        //searchInput = e.target.searchInput.value;//検索ワード取得

        if(searchInput.length === 0){
            errorFlg = true;
            setErrorMsg('個体識別番号を入力してください。');
        }else if(searchInput.length !== 10){
            errorFlg = true;
            setErrorMsg('個体識別番号は10ケタで入力してください。');
        }else{
            setErrorMsg('');
            setloadingMsg('「' + searchInput + '」を検索しています...');
            scroll.scrollToTop();
        }

        // 検索(Ajax loading)開始
        if(!errorFlg){
            
            setLayoutMode('loading');//画面切り替え(検索結果を表示)

            //fetchItems(searchInput);
            let ajaxUrlAll = ajaxUrl + searchInput + '&nonce=' + ajaxNonce + '&v=' + Date.now();
            //console.log(ajaxUrlAll);

            fetch(ajaxUrlAll)
            .then(response => {//Promiseを返す
                return response.json();//jsonデータをJavaScriptオブジェクトに
            })
            .then(data => {
                setSearchResultData(data);//検索結果表示
                setLayoutMode('result');//画面切り替え
                setloadingMsg('');//Loadingメッセージ初期化
            })
            .catch(error => {
                //console.log(error);
                setErrorMsg(error + '<br>検索時エラーが発生しました。');
            });

        }
    };

    //一部は妥協してcss(data-layout={layoutMode})で要素を非表示している
    return (
        <div class="search-area" data-layout={layoutMode}>
            <div class="search-intro">
                <p class="intro">牛の個体識別番号(10ケタ)を入力してください。</p>
                <Errors msg={errorMsg} errorClass="error-msg" />
                <form onSubmit={handleSubmit}>
                    <input type="text" id="searchInput" name="searchInput" onChange={handleChangeText} value={searchInput} placeholder="個体識別番号(10ケタ)" />
                    <Btn msg="検索する" mytype="submit" myicon="icon-arrow-right-white" myclass="btn btn-center btn-radius" />
                </form>
            </div>
            <Loading msg={loadingMsg} />
            <Results result={searchResultData} />
            <Btn msg="検索画面へ戻る" mytype="button" myicon="icon-arrow-left-blue" myclass="btn btn-back btn-radius search-btn-back" btnFnc={handleBackBtn} />
        </div>
    );

};
export default App;